module.exports = __webpack_public_path__ + "static/media/boston-scientific.9fc47c31.png";